// extracted by mini-css-extract-plugin
export default {"cds":"ContactDetails_cds__mWRrT","smL":"ContactDetails_smL__4-I9P","ContactDetails":"ContactDetails_ContactDetails__+AurJ"};